var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "start-screen" }, [
    _c(
      "div",
      {
        staticClass: "start-screen-option start-screen-option--lookup",
        on: {
          click: function($event) {
            return _vm.$router.push({ name: "Lookup" })
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "start-screen-option start-screen-option--compare",
        on: {
          click: function($event) {
            return _vm.$router.push({ name: "Compare" })
          }
        }
      },
      [_vm._m(1)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "start-screen-option start-screen-option--wizard",
        on: {
          click: function($event) {
            return _vm.$router.push({ name: "Wizard" })
          }
        }
      },
      [_vm._m(2)]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "start-screen-option__content" }, [
      _c("div", { staticClass: "start-screen-option__text" }, [
        _c("h2", { staticClass: "start-screen-option__heading" }, [
          _vm._v("Is my enrollment platform supported?")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "start-screen-option__button",
            attrs: { id: "lookup-button" }
          },
          [_vm._v("\n          Platform Lookup\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "start-screen-option__content" }, [
      _c("div", { staticClass: "start-screen-option__text" }, [
        _c("h2", { staticClass: "start-screen-option__heading" }, [
          _vm._v("Compare multiple platforms side-by-side")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "start-screen-option__button",
            attrs: { id: "compare-button" }
          },
          [_vm._v("\n          Compare Platforms\n        ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "start-screen-option__content" }, [
      _c("div", { staticClass: "start-screen-option__text" }, [
        _c("h2", { staticClass: "start-screen-option__heading" }, [
          _vm._v("Help me choose the best platform")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "start-screen-option__button",
            attrs: { id: "wizard-button" }
          },
          [_vm._v("\n          Help Me Choose\n        ")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aa2f66e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa2f66e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartScreen.vue
// module id = null
// module chunks = 